import React from "react";
import "./headerRegistration.scss";

const HeaderRegistration = ({
  title,
  subtitle,
  colorTitle = "#fff",
  colorSubtitle = "#fff",
  titleWeight = "normal",
  textAlign = "start",
  width = 310,
}) => {
  return (
    <div className="header-registration" style={{ width, textAlign }}>
      <div
        className="title-header"
        style={{ color: colorTitle, fontWeight: `${titleWeight} !important` }}
      >
        <h1>{title}</h1>
      </div>
      <div className="subtitle-header" style={{ color: colorSubtitle }}>
        <p>{subtitle}</p>
      </div>
    </div>
  );
};

export default HeaderRegistration;
